var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.625C15.1989 11.625 15.3897 11.704 15.5303 11.8447C15.671 11.9853 15.75 12.1761 15.75 12.375V15C15.75 15.1989 15.671 15.3897 15.5303 15.5303C15.3897 15.671 15.1989 15.75 15 15.75C11.6185 15.75 8.37548 14.4067 5.98439 12.0156C3.5933 9.62452 2.25 6.38151 2.25 3C2.25 2.80109 2.32902 2.61032 2.46967 2.46967C2.61032 2.32902 2.80109 2.25 3 2.25H5.625C5.82391 2.25 6.01468 2.32902 6.15533 2.46967C6.29598 2.61032 6.375 2.80109 6.375 3C6.375 3.93 6.525 4.8375 6.8025 5.6775C6.885 5.94 6.825 6.2325 6.615 6.435L4.965 8.0925C6.045 10.215 7.785 11.955 9.9075 13.035L11.5575 11.385C11.7675 11.175 12.06 11.115 12.3225 11.1975C13.1625 11.475 14.0625 11.625 15 11.625ZM9 2.25H10.5V3.75H9M11.25 2.25H15.75V3.75H11.25M9 4.5H10.5V6H9M11.25 4.5H15.75V6H11.25M9 6.75H10.5V8.25H9M11.25 6.75H15.75V8.25H11.25",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.a954027490ca28304b7725c54abefcae.svg";
export { ForwardRef as ReactComponent };